<template>
  <div class="personalCenterPage h5content column" v-if="isfinish">
    <div class="fixbackbtn row" v-if="EnterFromGroupChat" @click="backClick">
      <div class="row flex-center">
        <div class="iconfont icon-xiangyoujiantou-copy backicon"></div>
        <div class="Rtext">返回</div>
      </div>
    </div>

    <UserInfo :self="currentCustomer"></UserInfo>

    <!--无患者信息提示-->
    <div class="noPatientPrompt row flex-center" v-if="!haspersonalInfo">
      <i class="iconfont icon-Infor lefticon"></i>
      <div class="flex-1">未绑定蓝莓象（his）患者</div>
    </div>
    <!--无患者信息提示-->

    <div class="flex-1 column botContent">
      <!--无患者信息-->
      <NoPatientInformation
        ref="NoPatientInformationcontent"
        v-if="!haspersonalInfo"
        @changebindActive="changebindActive"
      ></NoPatientInformation>

      <!--有患者信息-->
      <div class="hasInfo flex-1 column" v-if="haspersonalInfo">
        <!--标签-->
        <van-tabs
          v-if="hasEmpInfo"
          color="#28B8C3"
          ref="vanTabs"
          title-active-color="#28B8C3"
          v-model:active="tabActive"
          class="van-tabs-class"
          :line-width="vanLineWidth"
          line-height="2"
          @change="onTabChange"
        >
          <van-tab
            v-for="(row, index) in ScrollCategory"
            :title="row.name"
            :key="index"
          >
            <!-- 假设组件名是 row.componentsName 这里需要跟据组件名来渲染不同的组件 -->

            <div class="componentContent flex-1 column">
              <component
                :is="row.componentsName"
                :patientId="currentCustomer.patientId"
                @unBindSuccess="unBindSuccess"
                v-if="tabActive == row.value"
              ></component>
            </div>
          </van-tab>
        </van-tabs>
        <!--无员工信息-->
        <div class="pt40" v-else>
          <EmpUnbind></EmpUnbind>
        </div>
      </div>
    </div>

    <!--无患者信息-->
    <div class="p-footbtn" v-if="!haspersonalInfo">
      <div class="flex-1">
        <div
          class="btn submit P-Cursor"
          v-if="bindActive == 1"
          @click="toBind()"
        >
          确认绑定
        </div>
        <div
          class="btn submit P-Cursor"
          v-if="bindActive == 2"
          @click="toCreate()"
        >
          新建档案
        </div>
      </div>
    </div>
  </div>

  <!--选择门店-->
  <H5SelectStore
    :self="h5SelectStoreConfig"
    :clinicList="h5ClinicList"
    @storeChange="handleH5ClinicChange"
  ></H5SelectStore>

  <PLoading></PLoading>
</template>

<script>
import UserInfo from "@/components/personalCenter/userInfo.vue";
import NoPatientInformation from "@/components/personalCenter/noPatientInformation.vue";

import appointmentRecords from "@/components/personalCenter/appointmentRecords.vue";
import billingInfo from "@/components/personalCenter/billingInfo.vue";
import disposalInfo from "@/components/personalCenter/disposalInfo.vue";
import electronicMedicalRecords from "@/components/personalCenter/electronicMedicalRecords.vue";
import followUpRecords from "@/components/personalCenter/followUpRecords.vue";
import patientInfo from "@/components/personalCenter/patientInfo.vue";
import visitRecords from "@/components/personalCenter/visitRecords.vue";
import debugging from "@/components/publick/debugging.vue";
import ConsultingInfo from "@/components/personalCenter/consultingInfo.vue";
import PatientImaging from "@/components/personalCenter/patientImaging.vue";
import ToDoList from "@/components/personalCenter/toDoList.vue";
import TodayToDo from "@/components/personalCenter/todayTodo.vue";

import AdverseEvent from "@/components/personalCenter/adverseEvent.vue";
import ReportPush from "@/components/personalCenter/reportPush.vue";

import Test from "@/components/personalCenter/test.vue";

import { userStore } from "@/store/user.js";
import router from "@/router/index";

import EmpUnbind from "@/components/uninitialized/h5.vue";
import H5SelectStore from "@/components/personalCenter/seleteStore/h5SelectStore.vue";

import { getClinicListByWecom } from "@/api/options.js";
import {
  getMicroCluesByPatientId,
  WeChatBindCustomer,
  queryWeChatPatientDetails,
} from "@/api/patient.js";
import func from "@/util/func.js";
import { contactCardProps, showToast } from "vant";

import { loadingStore } from "@/store/loading.js";
import { useRoute } from "vue-router";

import { provide } from "vue";


// 定义常量：需要重新排列 tab 的 corpId 列表
const SPECIAL_CORP_IDS = [
  // 在这里添加需要特殊处理的 corpId
  "ww82e51ece6311fcc5", //开发用的
  "ww1b24fa156ed02e21", //藩后街
  "wwbd56678735d700bf", //蓝莓象
  // "ww2f83800af3fbe2f6", //立飞世嘉
];

const DEFAULT_COMPONENT_ORDER = [
  //几个特殊处理的位置
  "ReportPush",
  "patientInfo",
  "TodayToDo",
  "appointmentRecords",
  "disposalInfo",
  "billingInfo",
  "electronicMedicalRecords",
  "PatientImaging",
  "visitRecords",
  "followUpRecords",
  "ConsultingInfo",
  "AdverseEvent",
  "Test",
];

// 定义常量：特殊处理的 corpId 对应的模块顺序配置
const SPECIAL_CORP_TAB_CONFIG = {
  // corpId 为键，组件名数组为值，按照数组顺序显示模块
  ww82e51ece6311fcc5: DEFAULT_COMPONENT_ORDER, //开发用的
  ww1b24fa156ed02e21: DEFAULT_COMPONENT_ORDER, //藩后街
  wwbd56678735d700bf: DEFAULT_COMPONENT_ORDER
  // ww2f83800af3fbe2f6: DEFAULT_COMPONENT_ORDER, //立飞世嘉
};

export default {
  name: "personalCenterPage",
  props: [],
  components: {
    UserInfo,
    NoPatientInformation,
    appointmentRecords,
    billingInfo,
    disposalInfo,
    electronicMedicalRecords,
    followUpRecords,
    patientInfo,
    visitRecords,
    debugging,
    EmpUnbind,
    ConsultingInfo,
    PatientImaging,
    AdverseEvent,
    ToDoList,
    ReportPush,
    TodayToDo,
    Test,
    H5SelectStore,
  },
  data: function () {
    return {
      isfinish: false,
      haspersonalInfo: false,
      tabActive: "0",
      // 判断是否为电脑端，用于控制componentContent的样式
      isPcDevice: false,
      ScrollCategory: [
        {
          name: "患者资料",
          value: 0,
          componentsName: "patientInfo",
        },
        {
          name: "预约记录",
          value: 1,
          componentsName: "appointmentRecords",
        },
        {
          name: "处置信息",
          value: 2,
          componentsName: "disposalInfo",
        },
        {
          name: "收费信息",
          value: 3,
          componentsName: "billingInfo",
        },
        {
          name: "电子病历",
          value: 4,
          componentsName: "electronicMedicalRecords",
        },
        {
          name: "影像",
          value: 5,
          componentsName: "PatientImaging",
        },
        {
          name: "回访记录",
          value: 6,
          componentsName: "visitRecords",
        },
        {
          name: "随访记录",
          value: 7,
          componentsName: "followUpRecords",
        },
        {
          name: "咨询信息",
          value: 8,
          componentsName: "ConsultingInfo",
        },
        {
          name: "不良事件",
          value: 9,
          componentsName: "AdverseEvent",
        },
        // {
        //   name: "待办",
        //   value: 11,
        //   componentsName: "ToDoList",
        // },
        {
          name: "今日待办",
          value: 12,
          componentsName: "TodayToDo",
        },
        {
          name: "报告推送",
          value: 10,
          componentsName: "ReportPush",
        },
        // {
        //   name: "调试",
        //   value: 13,
        //   componentsName: "Test"
        // }
      ],
      currentCustomer: {}, //当前客户信息
      hasEmpInfo: true,
      EnterFromGroupChat: false,
      bindActive: 1,
      h5ClinicList: [],
      h5SelectStoreConfig: { //选择门店配置
        isShow: false,
        current: "",
      },
      isReplacingClinic: false,
      pendingClinicResolve: null,
      pendingClinicPrevRes: null,
    };
  },
  computed: {
    vanLineWidth() {
      const that = this;
      const { tabActive, ScrollCategory } = that;
      const target = ScrollCategory.find(
        (item) => item.value.toString() === tabActive.toString(),
      );

      return target ? target.name.length * 14 + 24 : 50; // 计算宽度，14px 是每个字符的宽度，24px 是左右内边距
    },
  },
  setup() {
    let loading = loadingStore();
    const route = useRoute();

    const customerId = route.query.customerId || "";
    // 从 URL 获取初始的 tabActive 参数
    const initialTabActive = route.query.tabActive || "";

    return {
      loading,
      customerId,
      initialTabActive,
    };
  },
  mounted: function () {
    let that = this;



    const user = userStore();

    // 检测设备类型，判断是否为电脑端
    that.checkDeviceType();

    // 获取 corpId 并判断是否需要重新排列 tab
    that.checkAndRearrangeTabs(user.corpId);

    // 开发环境：跳过企微 token 等待，直接展示页面（避免 testHasToken 轮询阻塞）
    if (process.env.NODE_ENV === "development") {
      that.isfinish = true;
      user.setCusId("wm219eaAAAPNyWdZQOaxkmfafxNmH7eQ");
      that.GetCustomerInformation("wm219eaAAAPNyWdZQOaxkmfafxNmH7eQ");
      that.handleInitialTabActive();
      return;
    }

    that.loading.showLoading();

    user
      .testHasToken()
      .then((res) => {

        //开始刷新Token的监听
        user.refreshTokenTime();
        return that.ensureWecomClinicValid(res);
      })
      .then((res) => {
        if (func.isEmpty(that.customerId)) {
          //获取当前选中的客户
          return user.getAgentConfig();
        } else {
          //如果传入了客户id
          that.isfinish = true;
          that.loading.hideLoading();
          that.EnterFromGroupChat = true;
          user.setCusId(that.customerId);
          user.getWxconfig([
            "getContext",
            "getCurExternalContact",
            "sendChatMessage",
            "updateEnterpriseChat",
            "setClipboardData",
          ]);
          that.GetCustomerInformation(that.customerId);
        }
        // // 按 clinic.md：校验 token 内 clinic_id 是否在企微门店列表中
        // // - 若存在：直接放行（resolve），不影响后续 then 的 res 传递
        // // - 若不存在：切换到门店列表第一个（replacementClinic）后再放行
        // return that.ensureWecomClinicValid(res);
      })
      .then((res) => {
        //当前选中的用户
        that.isfinish = true;
        that.loading.hideLoading();
        res && that.GetCustomerInformation(res);
        //获取切换到当前项的tab
        this.handleInitialTabActive();
      })
      .catch((err) => {
        that.loading.hideLoading();
      });
  },
  methods: {
    /**
     * 确保当前 token 中的 clinic_id 在企微关联门店列表中
     * @param {*} prevRes - 上一个 then 传下来的结果（需要原样透传）
     * @returns {Promise<*>} - resolve(prevRes)，保证不影响现有 Promise 链路
     */
    ensureWecomClinicValid(prevRes) {
      const user = userStore();

      const { corpId, cusId, userInfo } = user || {};
      const currentClinicId = userInfo?.detail?.clinic_id || "";

      return getClinicListByWecom({ corpId, cusId })
        .then((res) => {
          const clinicList = res?.data?.data || [];

          // 门店列表为空：直接放行
          if (!Array.isArray(clinicList) || clinicList.length === 0) {
            return prevRes;
          }

          // 当前 clinic_id 存在于列表：直接放行
          const hasClinicIdInList = clinicList.some(
            (clinicItem) => clinicItem?.id == currentClinicId,
          );
          if (hasClinicIdInList) {
            return prevRes;
          }

          // 只有一个门店时无需用户选择，直接切换后继续后续加载
          if (clinicList.length === 1) {
            const defaultClinic = clinicList[0];
            const defaultClinicId = defaultClinic?.id || "";

            // 门店数据不完整：直接放行，避免阻断主流程
            if (!defaultClinicId) {
              return prevRes;
            }

            return user.replacementClinic(defaultClinicId).then(() => prevRes);
          }

          // 多个可选门店时交给用户选择，选择完成后再恢复原 Promise 链路
          return this.openH5SelectStore(clinicList, prevRes);
        })
        .catch(() => {
          // 门店校验失败：不阻断主流程，直接放行
          return prevRes;
        });
    },
    openH5SelectStore(clinicList, prevRes) {
      this.loading.hideLoading();
      this.h5ClinicList = clinicList;
      this.h5SelectStoreConfig = {
        isShow: true,
        current: "",
      };
      this.pendingClinicPrevRes = prevRes;

      // 暂停初始化流程，等待用户选择门店并完成 token 内门店切换
      return new Promise((resolve) => {
        this.pendingClinicResolve = resolve;
      });
    },
    handleH5ClinicChange(row) {
      const selectedClinicId = row?.id || "";
      const resolveClinicSelect = this.pendingClinicResolve;

      if (!selectedClinicId || !resolveClinicSelect || this.isReplacingClinic) {
        return;
      }

      const user = userStore();
      this.isReplacingClinic = true;
      this.loading.showLoading();

      user
        .replacementClinic(selectedClinicId)
        .then(() => {
          this.h5SelectStoreConfig.isShow = false;
          this.pendingClinicResolve = null;
          //继续之前的流程
          resolveClinicSelect(this.pendingClinicPrevRes);
          this.pendingClinicPrevRes = null;
        })
        .catch(() => {
          showToast("切换门店失败，请重新选择");
          this.h5SelectStoreConfig.current = "";
          this.loading.hideLoading();
        })
        .finally(() => {
          this.isReplacingClinic = false;
        });
    },
    /**
     * 检测是否为电脑端设备
     * 如果是电脑端则为componentContent元素添加pcpadding样式
     */
    checkDeviceType() {
      // 通过浏览器的User-Agent判断是否为电脑端
      const userAgent = navigator.userAgent;
      // 检查是否包含桌面操作系统的标识，且不包含移动设备的标识
      const isDesktop =
        /Windows NT|Macintosh|Linux/i.test(userAgent) &&
        !/Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          userAgent,
        );
      this.isPcDevice = isDesktop;
    },
    /**
     * 根据组件名数组重新排序 ScrollCategory
     * 只显示配置数组中包含的组件，按照数组顺序排列
     * @param {Array<string>} componentOrder - 组件名数组，定义显示顺序
     */
    sortScrollCategoryByConfig(componentOrder) {
      if (!componentOrder || !Array.isArray(componentOrder)) {
        return;
      }

      // 根据配置数组过滤并重新排序
      const sortedCategory = componentOrder
        .map((componentName, index) => {
          const foundItem = this.ScrollCategory.find(
            (item) => item.componentsName === componentName,
          );
          if (foundItem) {
            return {
              ...foundItem,
              value: index,
            };
          }
          return null;
        })
        .filter((item) => item !== null);

      this.ScrollCategory = sortedCategory;
    },

    /**
     * 检查 corpId 并重新排列 tab 顺序
     * 如果 corpId 在特殊列表中，则根据配置项重新排列模块顺序
     * @param {string} corpId - 当前用户的 corpId
     */
    checkAndRearrangeTabs(corpId) {
      // 检查 corpId 是否在特殊处理列表中
      const isSpecialCorpId = SPECIAL_CORP_IDS.includes(corpId);

      if (isSpecialCorpId) {
        // 获取对应的配置项
        const tabConfig = SPECIAL_CORP_TAB_CONFIG[corpId];
        if (tabConfig) {
          // 根据配置项重新排序
          this.sortScrollCategoryByConfig(tabConfig);
          // 设置默认选中报告推送（第一个）
          this.tabActive = "0";
        }
      } else {
        // 如果不在特殊处理列表中，则移除报告推送tab和今日待办tab
        this.ScrollCategory = this.ScrollCategory.filter(
          (item) => item.componentsName !== "TodayToDo",
        );

        //重构数组设置value
        this.ScrollCategory = this.ScrollCategory.map((item, index) => ({
          ...item,
          value: index,
        }));

        //设置默认选中第一个
        this.tabActive = "0";
      }
    },
    //获取顶部的客户、患者信息
    GetCustomerInformation(cusId) {
      let that = this;
      let { corpId, agentId } = userStore();

      getMicroCluesByPatientId({
        cusId,
        corpId,
        agentId,
      })
        .then((res) => {
          let { data } = res.data;
          let patientId;

          if (func.isEmpty(data)) {
            //找不到企业客户
          } else {
            patientId = data?.patientId;

            //当前用户信息
            that.currentCustomer = data;
            that.haspersonalInfo = !!patientId;
          }
          //获取当前患者信息
          return patientId ? queryWeChatPatientDetails({ patientId }) : null;
        })
        .then((res) => {
          const data = res ? res.data.data : null;

          if (func.isEmpty(data)) {
            return;
          }

          //需要展示的患者信息
          that.currentCustomer.patientName = data.patientName;
          that.currentCustomer.sexLabel = data.sexLabel;
          that.currentCustomer.age = data.age;

          //存储客户信息 data
          const user = userStore();
          user.setCusInfo(that.currentCustomer);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setEmpinfoStatus(status) {
      //设置是否有员工信息
      this.hasEmpInfo = status;
    },
    unBindSuccess() {
      //用户取消绑定成功
      let that = this;
      const user = userStore();
      that.GetCustomerInformation(user.cusId);
    },
    toBind() {
      let that = this;

      // 获取 NoPatientInformation 组件的实例
      const noPatientInfoComponent = this.$refs.NoPatientInformationcontent;

      // 判断 listSelect.id 是否为空
      if (
        noPatientInfoComponent &&
        noPatientInfoComponent.listSelect &&
        noPatientInfoComponent.listSelect.id
      ) {
        // 获取 listSelect.id
        const patientId = noPatientInfoComponent.listSelect.id;
        const user = userStore();
        that.loading.showLoading();
        WeChatBindCustomer({
          corpId: user.corpId,
          cusId: user.cusId,
          patientId: patientId,
        }).then((res) => {
          that.GetCustomerInformation(user.cusId);
          that.loading.hideLoading();
        });
        // 调用绑定接口，这里假设有一个名为 bindApi 的函数
        // this.bindApi(listSelectId);
      } else {
        // 提示选择要绑定的患者
        showToast("请选择要绑定的患者");
      }
    },
    backClick() {
      const user = userStore();
      let { agentId, corpId } = user;
      let state = agentId + corpId;
      router.replace({
        name: "groupChatEntrance",
        query: {
          state,
        },
      });
    },
    changebindActive(e) {
      this.bindActive = e;
    },
    toCreate() {
      //新建档案

      //调用 NoPatientInformation 组件的 toCreat 方法

      // 获取 NoPatientInformation 组件实例
      let comp = this.$refs.NoPatientInformationcontent;
      // 检查组件实例是否存在
      if (comp && typeof comp.toCreate === "function") {
        // 调用 NoPatientInformation 组件的 toCreat 方法
        comp.toCreate();
      } else {
        console.error(
          "NoPatientInformationcontent 组件实例未找到或 toCreat 方法不存在",
        );
      }
    },
    /**
     * 处理初始的 tabActive 参数
     * 确保 haspersonalInfo 为 true 且 tabs 加载完成后才进行切换
     */
    handleInitialTabActive() {
      const that = this;

      // 从路由中获取 initialTabActive 参数
      const initialTabValue = that.initialTabActive;

      // 如果有初始的 tab 值，则尝试匹配对应的 ScrollCategory 项目
      if (initialTabValue !== "") {
        // 在 ScrollCategory 中查找对应的项目
        const targetTab = that.ScrollCategory.find(
          (item) => item.value.toString() === initialTabValue.toString(),
        );

        // 如果找到匹配的项目，则设置 tabActive 为数字类型
        if (targetTab) {
          that.tabActive = targetTab.value; // 设置为数字类型
        }
      }
    },
    /**
     * tab 切换事件处理
     * 更新 URL 参数，添加当前的 tabActive
     * @param {string|number} tabValue - 当前激活的 tab 值
     */
    onTabChange(tabValue) {
      const that = this;

      // 更新 URL 参数，保留其他查询参数
      const currentQuery = { ...that.$route.query };
      currentQuery.tabActive = tabValue.toString();

      // 使用 replace 而不是 push，避免产生历史记录
      router.replace({
        name: that.$route.name,
        query: currentQuery,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.personalCenterPage {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.botContent {
  box-sizing: border-box;
  background-color: #ededed;
  height: 0;
}

.noPatientPrompt {
  background-color: #fff7e8;
  color: #333333;
  font-size: 0.25rem;
  padding: 0.167rem 0.25rem;
  text-align: left;
  flex-shrink: 0;

  .lefticon {
    font-size: 0.292rem;
    width: 0.417rem;
    color: #faad14;
    position: relative;
    top: 0.021rem;
  }
}

.hasInfo {
  background-color: #f7f7f7;
  border-radius: 0.083rem;
  height: 0;

  .van-tabs-class {
    flex: 1;
    height: 0;
    display: flex;
    flex-direction: column;
    :deep {
      .van-tabs__wrap {
        flex-shrink: 0;
        height: 0.75rem;
        .van-tabs__nav {
          height: 0.75rem;
          border: none;
          margin: 0;
          .van-tab {
            border: none;
            .van-tab__text {
              font-weight: normal;
            }
          }
        }
      }

      .van-tabs__content {
        flex: 1;
        height: 0;
        display: flex;
        flex-direction: column;

        .van-tab__panel {
          flex: 1;
          height: 0;
          display: flex;
          flex-direction: column;
        }
      }
    }
  }

  .componentContent {
    padding: 0 0.25rem;
    &.pcpadding {
      padding: 0 0 0 0.25rem;
    }
    overflow-y: scroll;
    margin-top: 0.25rem;
    background-color: #f7f7f7;
    height: 0;
  }
}

.fixbackbtn {
  text-align: left;
  background-color: #f6f6f7;
  padding: 0.208rem 0;
  padding-left: 0.208rem;
  height: 0.833rem;
  .backicon {
    color: #333333;
    margin-right: 0.1rem;
  }
  .Rtext {
    color: #28b8c3;
    font-size: 0.292rem;
  }
}
</style>
